import { render, staticRenderFns } from "./ModelKey.vue?vue&type=template&id=b6054da8&scoped=true"
import script from "./ModelKey.vue?vue&type=script&lang=js"
export * from "./ModelKey.vue?vue&type=script&lang=js"
import style0 from "./ModelKey.vue?vue&type=style&index=0&id=b6054da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6054da8",
  null
  
)

export default component.exports